import { Inject, Injectable } from '@angular/core';
import { Paginator } from '@app/classes';
import { AuthService } from '@app/services';
import { Node } from '@models/documents/directory/node.model';
import { DocumentTag } from '@models/documents/document-tag.model';
import { Table } from '@table/classes/table.class';
import { MenuColumnItem } from '@table/interfaces/menu-column-item.interface';
import { FolderColumn, ModifiedAtColumn, NameColumn, SourceTypeColumn } from './columns';

@Injectable()
export class AllDocumentNodesIndexTable extends Table {
    links = false;
    unnavigableLink = true;

    showMenuColumnOptions = true;
    bulkSelect = true;

    allowDragAndDrop = true;
    showGrippyOnCheckbox = true;
    private pathRoot: string = 'documents-v2';
    private _documentMenuColumnOptions: MenuColumnItem[] = [
        {
            label: 'document.download',
            event: 'download',
        },
        {
            label: 'document.delete',
            event: 'deleteDocument',
        },
    ];

    private _folderMenuColumnOptions: MenuColumnItem[] = [
        {
            label: 'document.rename',
            event: 'rename',
        },
        {
            label: 'document.delete',
            event: 'deleteFolder',
        },
    ];

    constructor(
        protected auth: AuthService,
        @Inject([]) private nodeIds: number[]
    ) {
        super(auth);
        this.boot();
    }

    getMenuColumnOptionsForRow(row: Node): MenuColumnItem[] {
        if (row.isFolder()) {
            return this._folderMenuColumnOptions;
        }
        return this._documentMenuColumnOptions;
    }

    getLink(row: Node): (string | number)[] | null {
        if (row.isFolder()) {
            return ['/' + this.pathRoot, 'center', 'folders', row.id];
        }
        return ['/' + this.pathRoot, 'center', row.sourceId];
    }

    setColumns(): void {
        this.columns = [new NameColumn(null), new SourceTypeColumn(), new FolderColumn(), new ModifiedAtColumn()];
    }

    setTags(selectedTags?: Set<DocumentTag>): this {
        const tags = selectedTags
            ? Array.from(selectedTags).map((documentTag: DocumentTag): number => documentTag.id)
            : [];
        this.paginator.filters = { ...this.paginator.filters, tags };

        return this;
    }

    setDataSource(): void {
        this.paginator = new Paginator(
            Node.with(['source.file', 'parent']).where('recursive', true).whereIn('node', this.nodeIds)
        );
    }
}
